import { queryOptions, useQuery, keepPreviousData } from '@tanstack/react-query'
import { api } from '@/lib/api-client'
import { QueryConfig } from '@/lib/react-query'

export type BackupToolReportModel = {
    accountId: string
    accountName: string
    ownerEmails: string | null
    ownerPhoneNumbers: string | null
    activeStores: number
    hasFastboundUsers: boolean
    totalAttachments: number
    hasInstalledBackupTool: boolean
    attachmentsNeedingBackup: number
    attachmentsBackedUp: number
    lastBackupDate: string | null
    timeSinceLastBackup: string
    daysSinceLastBackup: number | null
    percentNeedingBackup: number
}

export type BackupToolReportResponse = {
    backupToolReports: BackupToolReportModel[]
    totalCount: number
}

export type BackupToolReportFilter = {
    startIndex?: number
    limit?: number
    sort?: string
    sortOrder?: 'asc' | 'desc'
    accountName?: string
    hasFastboundUsers?: boolean
    hasInstalledBackupTool?: boolean
    minDaysSinceLastBackup?: number
    minAttachmentsNeedingBackup?: number
}

export const getBackupToolReport = async (filter: BackupToolReportFilter): Promise<BackupToolReportResponse> => {
    return api.get('/reports/BackupToolReport', { params: filter })
}

export const getBackupToolReportQueryOptions = (filter: BackupToolReportFilter) => {
    return queryOptions({
        queryKey: ['backup-tool-report', filter],
        queryFn: () => getBackupToolReport(filter),
    })
}

type UseBackupToolReportOptions = {
    filter?: BackupToolReportFilter
    queryConfig?: QueryConfig<typeof getBackupToolReport>
}

export const useBackupToolReport = ({ filter = {}, queryConfig }: UseBackupToolReportOptions = {}) => {
    return useQuery({
        ...getBackupToolReportQueryOptions(filter),
        placeholderData: keepPreviousData,
        ...queryConfig,
    })
}

